import React, { useState } from 'react'
import {
	Box,
	Heading,
	Text,
	Textarea,
	Button,
	Alert,
	AlertIcon,
	VStack,
	FormControl,
	FormLabel,
	useToast,
	useColorModeValue,
} from '@chakra-ui/react'

import { parseRankImport } from '../../ranking/rankingState'

export default function Step0(props) {
	const [importData, setImportData] = useState('')
	const toast = useToast()
	const bodyMuted = useColorModeValue('gray.600', 'bgg.muted')

	const handleImport = () => {
		try {
			const v2 = parseRankImport(importData)
			props.onImportRank(v2)
		} catch (e) {
			toast({
				title: 'Could not import',
				description: e instanceof Error ? e.message : 'Invalid JSON or format.',
				status: 'error',
				duration: 6000,
				isClosable: true,
			})
		}
	}

	return (
		<VStack spacing={5} align="stretch">
			<Box>
				<Heading as="h3" size="md" mb={2}>
					Import saved tiers
				</Heading>
				<Text color={bodyMuted} fontSize="sm">
					Paste JSON from a previous export (v2 or legacy array) to jump straight to the results table.
				</Text>
			</Box>
			<FormControl>
				<FormLabel fontSize="sm" fontWeight="600">
					JSON
				</FormLabel>
				<Textarea
					placeholder="Paste export here…"
					onChange={(e) => setImportData(e.target.value)}
					value={importData}
					rows={10}
					fontSize="sm"
					rounded="lg"
				/>
			</FormControl>
			<Button
				onClick={handleImport}
				colorScheme="brand"
				variant="solid"
				isDisabled={importData.trim().length === 0}
				size="lg"
				rounded="lg"
			>
				Import and view
			</Button>
			<Alert status="warning" variant="subtle" rounded="lg" fontSize="sm">
				<AlertIcon />
				Invalid JSON can break this step. Reload the page if something looks wrong.
			</Alert>
		</VStack>
	)
}
